import React, { useState, useEffect, useCallback } from 'react';
import TableToolbox from '../../components/TableToolbox';
import NewUser from './NewVendor';
import useStyles from './styles';
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import EnhancedTableHead from '../../components/DataTables/TableHead';
import { connect } from 'react-redux';
import { fetchVendorList } from '../../redux/actions/adminActions/vendorList';
import { deleteVendor } from '../../redux/actions/adminActions/deleteVendor';
import {
  applySortFilter,
  getComparator,
  getErrorMessage,
  secondaryTableCell,
  tableCell,
  vendorTempObj,
} from '../../utils/appUtils';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@material-ui/core';
import { Strings } from '../../utils/strings';
import { useAlert } from 'react-alert';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomizedTooltips from '../../components/CustomizedTooltips';
import { icons } from '../../utils/icons';
import CommonDialog from '../../components/CommonDialog';
import debounce from 'lodash/debounce';

// ======== Table Head =========
const headCells = [
  { id: 'fullName', label: 'NAME', isSort: true },
  { id: 'email', label: 'EMAIL', isSort: true },
  { id: 'phoneNo', label: 'PHONE' },
  { id: 'category', label: 'CATEGORY', isSort: true },
  { id: '' },
];

const Vendor = (props) => {
  const classes = useStyles();
  const [newDialog, setNewDialog] = useState(false);
  const alert = useAlert();
  // const [vendorListData, setVendorListData] = useState([]);
  const vendorListData = props.vendorListData || [];
  const [search, setSearch] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({});
  const [deleteVendorDialog, setDeleteVendorDialog] = useState(false);
  const [preferredVendorProgram, setPreferredVendorProgram] = useState(false);
  const [openRows, setOpenRows] = useState([]);

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };
  const delayedSearch = useCallback(
    debounce(
      (q) =>
        props?.fetchVendorList(q, preferredVendorProgram, (err) =>
          onError(err)
        ),
      600
    ),
    [preferredVendorProgram]
  );

  useEffect(() => {
    props.fetchVendorList(search, preferredVendorProgram, (err) =>
      onError(err)
    );
  }, [
    props.addVendorData,
    props.updateVendorData,
    props.deleteVendorData,
    preferredVendorProgram,
    // search,
  ]);

  // useEffect(() => {
  //   const data = props.vendorListData ? props.vendorListData : [];
  //   setVendorListData(data);
  // }, [props.vendorListData]);

  const onDeleteData = async () => {
    await props.deleteVendor(
      selectedVendor._id,
      () => setDeleteVendorDialog(false),
      onError
    );
  };

  const descendingComparator = (a, b, orderBy) => {
    if (a[orderBy] === undefined) return -1;
    if (b[orderBy] === undefined) return 1;
    let asceding;
    let descding;
    if (orderBy === 'category') {
      asceding =
        b[orderBy]?.categoryName?.toLowerCase() <
        a[orderBy]?.categoryName?.toLowerCase();
      descding =
        b[orderBy]?.categoryName?.toLowerCase() >
        a[orderBy]?.categoryName?.toLowerCase();
    } else {
      asceding = b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase();
      descding = b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase();
    }
    if (asceding) return -1;
    if (descding) return 1;
    return 0;
  };

  const handleRequestSort = (event, property) => {
    setOpenRows([]);
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const filteredVendors = applySortFilter(
    vendorListData,
    getComparator(order, orderBy, descendingComparator)
  );

  const onOpenRow = (rowIndex) => {
    if (openRows.findIndex((item, index) => item === rowIndex) === -1) {
      setOpenRows([...openRows, rowIndex]);
    } else {
      setOpenRows(openRows.filter((item) => item !== rowIndex));
    }
  };

  const redirectToItem = async () => {
    if (vendorListData?.length > 0 && state?.id) {
      const fIndexOfJob = filteredVendors?.findIndex(
        (el) => el?._id === state.id
      );
      const fRowIndex = openRows?.findIndex((el) => el === fIndexOfJob);
      if (fRowIndex === -1) {
        await onOpenRow(fIndexOfJob);
      }
      let elem = document.getElementById(state.id);
      let wrapper = document.getElementById('mainContainer');
      if (elem) {
        // elem.scrollIntoView({ behavior: 'smooth', block: 'end' });
        let count = elem.offsetTop - wrapper.scrollTop;
        wrapper.scrollBy({ top: count, left: 0, behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    redirectToItem();
  }, [state, vendorListData]);

  return (
    <div className={classes.vendor_container} id='mainContainer'>
      <TableToolbox
        isSearch
        // isFilter
        isPrimaryButton
        search={search}
        onChangeSearch={(e) => {
          delayedSearch(e.target.value);
          setSearch(e.target.value);
        }}
        onNewClick={() => setNewDialog(true)}
        isSecondaryButton
        secondaryButtonText={Strings.CATEGORY_TYPES}
        secondaryButtonClick={() =>
          navigate('/app/vendor/categories', {
            state: {
              type: 'vendor',
            },
          })
        }
        isToggle={true}
        toggleLabel={Strings.PREFERRED_VENDOR_PROGRAM}
        toggleValue={preferredVendorProgram}
        onChangeToggle={() =>
          setPreferredVendorProgram(!preferredVendorProgram)
        }
      />
      <div className={classes.list_container}>
        {props.vendorListLoading ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : (
          <>
            {vendorListData.length === 0 ? (
              <div className={classes.flexView}>
                <p className={classes.no_data_message}>
                  {Strings.NO_DATA_FOUND}
                </p>
              </div>
            ) : (
              <TableContainer>
                <Table sx={{ minWidth: 930 }} aria-labelledby='tableTitle'>
                  <EnhancedTableHead
                    headCells={headCells}
                    handleRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  <TableBody>
                    {vendorListData &&
                      filteredVendors?.map((data, index) => {
                        const {
                          fullName,
                          email,
                          phoneNo,
                          category,
                          address,
                          preferredTechnician,
                          techPhone,
                          websiteLink,
                          notes,
                        } = data;
                        let detailArr = [];
                        if (
                          preferredTechnician !== '' &&
                          preferredTechnician !== undefined
                        ) {
                          detailArr.push({ preTech: preferredTechnician });
                        }
                        if (techPhone !== '' && techPhone !== undefined) {
                          detailArr.push({ techPhone: techPhone });
                        }
                        if (address !== '' && address !== undefined) {
                          detailArr.push({ address: address });
                        }
                        if (websiteLink)
                          detailArr.push({ websiteLink: websiteLink });
                        if (notes) detailArr.push({ notes: notes });
                        return (
                          <React.Fragment key={data._id + index}>
                            <TableRow
                              id={data._id}
                              sx={{ width: '100%' }}
                              onClick={() => onOpenRow(index)}
                            >
                              <TableCell
                                style={{
                                  ...tableCell(theme, openRows.includes(index)),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='row'
                                  alignItems='flex-start'
                                >
                                  <img
                                    className={classes.toggle_arrow}
                                    src={
                                      openRows.includes(index)
                                        ? icons(theme).downArrow
                                        : icons(theme).rightArrow
                                    }
                                    alt=''
                                  />
                                  <label className={classes.name_cell}>
                                    {fullName}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(theme, openRows.includes(index)),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='column'
                                  alignItems='flex-start'
                                >
                                  <label className={classes.common_cell}>
                                    {email || '-'}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(theme, openRows.includes(index)),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='column'
                                  alignItems='flex-start'
                                >
                                  <label className={classes.common_cell}>
                                    {phoneNo}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(theme, openRows.includes(index)),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='column'
                                  alignItems='flex-start'
                                >
                                  <label className={classes.common_cell}>
                                    {category?.categoryName}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(theme, openRows.includes(index)),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='row'
                                  justifyContent='end'
                                  alignItems='flex-start'
                                >
                                  <CustomizedTooltips
                                    title={Strings.EDIT_VENDOR}
                                  >
                                    <img
                                      className={classes.action_icons}
                                      src={icons(theme).editIcon}
                                      style={{ marginRight: 15 }}
                                      alt=''
                                      onClick={(e) => {
                                        setIsEdit(true);
                                        setSelectedVendor(data);
                                        setNewDialog(true);
                                      }}
                                    />
                                  </CustomizedTooltips>
                                  <CustomizedTooltips
                                    title={Strings.DELETE_VENDOR_TT}
                                  >
                                    <img
                                      className={classes.action_icons}
                                      src={icons(theme).deleteIcon}
                                      alt=''
                                      onClick={(e) => {
                                        setSelectedVendor(data);
                                        setDeleteVendorDialog(true);
                                      }}
                                    />
                                  </CustomizedTooltips>
                                </Stack>
                              </TableCell>
                            </TableRow>
                            {openRows.findIndex((item) => item === index) !==
                              -1 &&
                              detailArr.map((item, ind) => {
                                return (
                                  Object.values(item)[0] && (
                                    <TableRow
                                      key={data._id + ind}
                                      sx={{ width: '100%' }}
                                    >
                                      <TableCell
                                        style={{
                                          ...secondaryTableCell(
                                            theme,
                                            detailArr.length === ind + 1
                                          ),
                                          cursor: 'pointer',
                                        }}
                                        component='td'
                                        scope='row'
                                      >
                                        <Stack
                                          direction='row'
                                          alignItems='center'
                                        >
                                          <label
                                            style={{
                                              marginLeft: 39,
                                              cursor: 'pointer',
                                            }}
                                            className={classes.name_cell}
                                          >
                                            {
                                              vendorTempObj[
                                                Object.keys(item)[0]
                                              ]
                                            }
                                          </label>
                                        </Stack>
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          ...secondaryTableCell(
                                            theme,
                                            detailArr.length === ind + 1
                                          ),
                                          cursor: 'pointer',
                                        }}
                                        component='td'
                                        scope='row'
                                        colSpan={5}
                                      >
                                        <Stack
                                          direction='row'
                                          alignItems='flex-start'
                                        >
                                          {vendorTempObj[
                                            Object.keys(item)[0]
                                          ] === 'Website Link' ? (
                                            <a
                                              target='_blank'
                                              href={Object.values(item)[0]}
                                              style={{
                                                fontSize: 14,
                                                color: '#0088CC',
                                              }}
                                            >
                                              {Object.values(item)[0]}
                                            </a>
                                          ) : (
                                            <label
                                              style={{
                                                cursor: 'pointer',
                                              }}
                                              className={classes.common_cell}
                                            >
                                              {Object.values(item)[0]}
                                            </label>
                                          )}
                                        </Stack>
                                      </TableCell>
                                    </TableRow>
                                  )
                                );
                              })}
                          </React.Fragment>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </div>
      {newDialog && (
        <NewUser
          onNewClose={() => {
            setIsEdit(false);
            setSelectedVendor({});
            setNewDialog(false);
          }}
          isEdit={isEdit}
          data={selectedVendor}
        />
      )}
      {deleteVendorDialog && (
        <CommonDialog
          title={Strings.VENDOR}
          message={Strings.DELETE_VENDOR}
          onSuccess={() => onDeleteData()}
          onClose={() => {
            setSelectedVendor({});
            setDeleteVendorDialog(false);
          }}
          loading={props.deleteVendorLoading}
        />
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  addVendorData: state.addVendorData.data,
  vendorListData: state.vendorListData.data,
  vendorListLoading: state.vendorListData.loading,
  updateVendorData: state.updateVendorData.data,
  deleteVendorData: state.deleteVendorData.data,
  deleteVendorLoading: state.deleteVendorData.loading,
});

export default connect(mapStateToProps, {
  fetchVendorList,
  deleteVendor,
})(Vendor);
